// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"171":"collection","185":"pdp","187":"report-issue","594":"demo","711":"warranty","962":"home"}[chunkId] + "." + {"171":"c3692995","185":"69d86b45","187":"efce7d75","594":"63e8d855","711":"e8daebb7","962":"3d8eeecd"}[chunkId] + ".js";
};